<script>
import { simpleComputed } from '@state/helpers'

export default {
  components: {},
  props: {
  },
  data() {
    return {
		}
  },
  computed: {
		...simpleComputed,
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<template>

	<div v-show="isShowingProgress" class="progress mb-0" style="height:5px">
		<div style="width: 100%" aria-valuenow="100" class="progress-bar progress-bar-striped bg-warning progress-bar-animated" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
	</div>

</template>

<style lang="scss">
</style>
